import { render, staticRenderFns } from "./EmulatorCustomizationDropdown.vue?vue&type=template&id=1ac835da&scoped=true"
import script from "./EmulatorCustomizationDropdown.vue?vue&type=script&lang=js"
export * from "./EmulatorCustomizationDropdown.vue?vue&type=script&lang=js"
import style0 from "./EmulatorCustomizationDropdown.vue?vue&type=style&index=0&id=1ac835da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac835da",
  null
  
)

export default component.exports